module.exports = __webpack_public_path__ + "img/guide1-1.f7a3e910.png";